import { useEffect, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { AccountLink, useHomePath } from "../../lib/session";
import { Logo } from "../../lib/ui";

export type LegalTab = "privacy" | "terms" | "delete";

const TABS: { id: LegalTab; to: string; label: string }[] = [
  { id: "privacy", to: "/privacy", label: "Privacy" },
  { id: "terms", to: "/terms", label: "Terms" },
  { id: "delete", to: "/delete-data", label: "Delete my data" },
];

/** Sets the tab title while a page is open and puts the old one back after. */
function useDocumentTitle(title: string) {
  useEffect(() => {
    const before = document.title;
    document.title = title;
    return () => {
      document.title = before;
    };
  }, [title]);
}

/** The header and footer shared by the three legal pages. */
export function LegalPage({ tab, title, children }: { tab: LegalTab; title: string; children: ReactNode }) {
  const home = useHomePath();
  useDocumentTitle(`${title} · ConfirmPay`);
  return (
    <div>
      <header className="wrap site-header lg-head">
        <Logo height={28} to={home} />
        <nav className="lg-nav" aria-label="Legal">
          {TABS.map((t) => (
            <Link key={t.id} to={t.to} aria-current={t.id === tab ? "page" : undefined}>
              {t.label}
            </Link>
          ))}
        </nav>
      </header>
      <main>{children}</main>
      <footer className="wrap lg-foot">
        <span>ConfirmPay is free for Singapore nonprofits and small businesses.</span>
        <nav aria-label="Legal pages">
          {TABS.map((t) => (
            <Link key={t.id} to={t.to}>
              {t.label}
            </Link>
          ))}
          <AccountLink>Sign in</AccountLink>
        </nav>
      </footer>
    </div>
  );
}
